const presentmentOptions = [
  {
    "key": "ORIGINAL_PRESENTMENT",
    "text": "Original presentment"
  },
  {
    "key": "FIRST_REPRESENTMENT",
    "text": "First representment"
  },
  {
    "key": "SECOND_REPRESENTMENT",
    "text": "Second representment"
  },
  {
    "key": "THIRD_REPRESENTMENT",
    "text": "Third representment"
  },
  {
    "key": "PREVIOUSLY_AUTHORIZED_REQUEST",
    "text": "Previously authorized request"
  },
  {
    "key": "RESUBMISSION",
    "text": "Resubmission"
  },
  // {
  //   "key": "CARD_VALIDATION",
  //   "text": "Card validation"
  // },
];

export default presentmentOptions;